<template>
  <div class="report-container">
    <div class="bg-logo"></div>
    <div class="flex-body">
      <div class="bg-wave"></div>
      <div class="report-header"></div>
      <div class="report-content">
        <div class="brief-info">
          <div class="left">
            <div :class="'info_result ' + genuineType.typeBgClass">
              <span>{{ genuineType.desp }}</span>
              <span v-if="genuineType.code == 33" class="patch" @click="patch">去补图</span>
            </div>
            <!-- <div class="info_desc_line">
              <div class="desc_label">鉴定品牌</div>
              <div class="desc_content">{{brandName}}</div>
            </div> -->
            <div class="info_desc_line">
              <div class="desc_label">鉴别编号</div>
              <div class="moaid-desc_content">{{OAID}}</div>
            </div>
            <div class="info_desc_line">
              <div class="desc_label">CODE</div>
              <div class="desc_content">{{sequence}}</div>
            </div>
            <div v-if="suggestion" class="info_desc_line">
              <div class="desc_label">鉴别评价</div>
              <div class="desc_content">{{suggestion}}</div>
            </div>
          </div>
          <div class="right">
            <img :src="genuineType.sealImg"/>
          </div>
        </div>
        <div class="split-line"></div>
        <div class="icon-line"></div>
        <div v-if="genuineType.desp == '无法鉴定'" class="no-result-container">
          <div class="tip-title">
            无法鉴别的常见原因
          </div>
          <div class="tips">
            1、图片清晰度较低；2、拍摄鉴定点位置不正确；<br/> 3、鉴定点变形等
          </div>
        </div>
      </div>
    </div>
    <div class="img-list">
      <div class="img-item" v-for="(item, index) in bytedanceImage" :key="item + index">
        <img :src="item" class="img">
      </div>
    </div>
    <div class="text111">
      <div>1、本报告属于图片鉴别报告，鉴别结果根据用户上传商品图片给出</div>
      <div>2、本报告可以给商家销售和买家购物提供参考价值</div>
      <div>3、本报告不等同于有法律效力的线下实物鉴定报告</div>
      <div>4、本报告受用户委托，依据中质协《商品人工智能鉴定方法通用规范》(T/CAQI 268-2022 )团体标准，由符合该团体标准的AI算法自动给出</div>
      <div>5、客服邮箱:{{ reportContactEmail }} 公司官网:{{ reportCompanyWebsite }}</div>
    </div>
    <div class="safe-bottom"></div>
  </div>
</template>

<script>
import { REPORT_COMPANY_WEBSITE, REPORT_CONTACT_EMAIL } from "@/common/constant";
import { Toast } from "vant";

const SEAL = {
  real: 'https://oss.turingsenseai.com/1628575872053959757.png',
  fake: 'https://oss.turingsenseai.com/1628679598180643073.png',
  unknow: 'https://oss.turingsenseai.com/1628582036592914079.png'
}
import Precent from './components/precent.vue'

const GENUINE_TYPE = {
  '0': {
    desp: '不符合正品工艺',
    sealImg: 'https://oss.turingsenseai.com/1720062019917982758.jpg',
    typeIcon: 'https://oss.turingsenseai.com/1628679595929512302.png', // 左边文字背景
    typeBgClass: 'fake'
  },
  '1': {
    desp: '符合正品工艺',
    sealImg: 'https://oss.turingsenseai.com/1720062021278931245.jpg',
    typeIcon: 'https://oss.turingsenseai.com/1628575456562452544.png',
    typeBgClass: 'real'
  },
  '2': {
    desp: '无法鉴定',
    sealImg: 'https://oss.turingsenseai.com/1720062017699925728.jpg',
    typeIcon: 'https://oss.turingsenseai.com/1628679595929512302.png', // 左边文字背景
    typeBgClass: 'fake'
  },
  '3': {
    desp: '待补图',
    sealImg: 'https://oss.turingsenseai.com/1628582036592914079.png',
    typeIcon: '', // 左边文字背景
    typeBgClass: '',
    code: 33
  },
  '4': {
    desp: '预计4-24小时内出结果，请耐心等待。',
  }
}

const AITOMANUAL_TYPE = {
  0: {
    desp: '预计4-24小时内出结果，请耐心等待。',
  },
  2: {
    desp: '不符合正品工艺',
    sealImg: 'https://oss.turingsenseai.com/1720062019917982758.jpg',
    typeIcon: 'https://oss.turingsenseai.com/1628679595929512302.png', // 左边文字背景
    typeBgClass: 'fake'
  },
  1: {
    desp: '符合正品工艺',
    sealImg: 'https://oss.turingsenseai.com/1720062021278931245.jpg',
    typeIcon: 'https://oss.turingsenseai.com/1628575456562452544.png',
    typeBgClass: 'real'
  },
  3: {
    desp: '无法鉴定',
    sealImg: 'https://oss.turingsenseai.com/1720062017699925728.jpg',
    typeIcon: 'https://oss.turingsenseai.com/1628679595929512302.png', // 左边文字背景
    typeBgClass: 'fake',
  },
  5: {
    desp: '待补图',
    sealImg: 'https://oss.turingsenseai.com/1628582036592914079.png',
    typeBgClass: '',
    code: 33
  },
}

export default {
  components: {
    Precent,
  },
  props: {
    brandName: {
      type: String,
      required: true,
      default: ""
    },
    OAID: {
      type: String,
      required: true,
      default: ""
    },
    kindID: {
      type: Number,
      required: true,
    },
    brandID: {
      type: Number,
      required: true,
    },
    seriesID: {
      type: Number,
      required: true,
    },
    hierarchy: {
      type: String,
      required: true,
    },
    sequence: {
      type: String,
      require: true,
      default: ""
    },
    genuine: {
      type: String,
      required: true,
      default: '1'
    },
    suggestion: {
      type: String,
      required: true,
      default: ''
    },
    bytedanceImage: {
      type: Array,
      default: () => {
        return []
      }
    },
    aIToManualResult: {
      type: Number,
      default: () => {
        return 3
      }
    },
    isToManualRealTimeOrder: {
      type: Boolean
    },
    isManual: {
      type: Boolean
    }
  },
  computed: {
    genuineType() {
      // console.log(GENUINE_TYPE, this)
      console.log(this.genuine, GENUINE_TYPE[this.genuine])
      let showResult = 0
      if(!this.isManual && this.isToManualRealTimeOrder) {
        showResult = this.aIToManualResult
        return AITOMANUAL_TYPE[showResult] || {}
      }else{
        showResult = this.genuine
        return GENUINE_TYPE[showResult] || {}
      }
    }
  },
  data() {
    return {
      seal: SEAL,
      screenWidth: document.documentElement.clientWidth, //屏幕宽度
      screenHeight: document.documentElement.clientHeight, //屏幕宽度
      reportContactEmail: REPORT_CONTACT_EMAIL,
      reportCompanyWebsite: REPORT_COMPANY_WEBSITE,
    }
  },
  methods: {
    patch(){
      let url;
      if(this.isManual){
        url = `/subPackages/ai/identify/butu/index?oaId=${this.OAID}&guaqian=1`
      }else{
        url = `/subPackages/ai/identify/aiButu/index?guaqian=1&oaId=${this.OAID}&key=${[this.kindID, this.brandID, this.seriesID][this.hierarchy]}`
      }

      if(window.__wxjs_environment === 'miniprogram'){
        wx.miniProgram.redirectTo({
          url,
          success: (res) => {
            console.log(res);
          },
          fail: (err) => {
            console.log(err);
          },
        });
      }else {
        Toast('请前往微信小程序 “我的-我的鉴别挂签” 找到订单，并完成补图操作~');
      }

    },
  }
}
</script>

<style lang="scss" scoped>
.detail_container {
  ::v-deep .van-tabs__wrap {
    height: 70px !important;
    .van-tabs__nav {
      padding: 0;
      .van-tab {
        padding: 0;
        margin-right: 40 * 2px;
        display: inline-block;
        color: #828393;
        text-align: center;
        .van-tab__text {
          font-size: 0.9em;
        }
      }
      .van-tab--active {
        border-bottom: none;
        padding-bottom: 0.2em;
        color: #2a2a30;
        font-weight: 500;
        &::after {
          content: "";
          width: 14 * 2px;
          height: 6px;
          position: absolute;
          top: 1.9em;
          left: 50%;
          transform: translateX(-50%);
          background-color: #2a2a30;
        }
      }
    }
    .van-tabs__line {
      display: none;
    }
  }
}

.img-list {
  margin-top: 12 * 2px;
  // padding: 0px 12 * 2px;
  box-sizing: border-box;
  .img-item {
    width: 100%;
    margin-top: 10 * 2px;
    .img {
      object-fit: cover;
      width: 100%;
    }
  }
}
.split-line {
  border-top: 1px solid #f0f0f5;
  width: 303 * 2px;
  margin: 12 * 2px auto 0;
  // 17 * 2px
}

.no-result-container {
  margin-top: 20 * 2px;
  .tip-title {
    font-size: 12 * 2px;
    color: #2A2A30;
    margin-bottom: 6 * 2px;
  }
  .tips {
    font-size: 12 * 2px;
    color: #828393;
  }

}

.report-container {
  width: 100%;
  min-height: 100vh;
  box-sizing: border-box;
  padding: 0 12 * 2px;
  display: flex;
  flex-direction: column;
  align-items: center;
  font-size: 20px;
  background: linear-gradient(270.23deg, #26262E 0.15%, #4D4D59 99.76%);
}
.bg-logo {
  height: 45 * 2px;
  width: 170 * 2px;
  margin: 25 * 2px 0;
  // background: url('https://oss.turingsenseai.com/1628564754186096854.png') no-repeat;
  // background: url('https://oss.turingsenseai.com/1661166582278630713.png') no-repeat;
  background: url('https://oss.turingsenseai.com/1680601007591196630.png') no-repeat;
  background-size: contain;
}
.flex-body {
  width: 100%;
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  overflow: hidden;
  background-color: #FFF;
}
.bg-wave {
  width: 100%;
  height: 170 * 2px;
  position: absolute;
  background: url('https://oss.turingsenseai.com/1628672040888830257.png') no-repeat;
  background-size: 100% 100%;
  pointer-events: none;
}
.report-header {
  margin: 16px 0;
  width: 200 * 2px;
  height: 38 * 2px;
  background: url('https://oss.turingsenseai.com/1720062022959131642.jpg') no-repeat;
  background-size: contain;
  z-index: 1;
}
.report-content {
  width: calc(100% - 16px);
  // margin-bottom: 20px;
  box-sizing: border-box;
  padding: 20 * 2px 16 * 2px;
  background-color: #FFF;
  color: #222;
  z-index: 1;
  .brief-info {
    width: 100%;
    display: flex;
    align-items: center;
    .left {
      display: flex;
      flex-direction: column;
      flex: 1;
      .info_result {
        width: fit-content;
        margin-bottom: 29 * 2px;
        font-size: 24 * 2px;
        line-height: 34 * 2px;
        font-weight: 600;
        background-position: 50% 50%;
        background-repeat: no-repeat;

        .patch {
          font-weight: 400;
          font-size: 12 * 2px;
          margin-left: 20px;
          color: #3a94ff;
          text-decoration: underline;
        }

        &.fake {
          background-size: 32 * 2px 32 * 2px;
          background-image: url("https://oss.turingsenseai.com/1628679595929512302.png");
        }
        &.real { // real
          background-size: 82px 60px;
          background-image: url("https://oss.turingsenseai.com/1628575456562452544.png");
        }
      }
      .info_desc_line {
        display: flex;
      }
      .desc_label, .desc_content, .moaid-desc_content {
        font-size: 12 * 2px;
        line-height: 17 * 2px;
        margin-bottom: 28px;
      }
      .desc_label {
        width: 152px;
        font-weight: 600;
      }
      .desc_content {
        flex: 1;
        color: #828393;
      }
      .moaid-desc_content {
        flex: 1;
        color: #828393;
        width: 210px;
        word-break: break-all;
      }
    }
    .right {
      width: 96 * 2px;
      height: 96 * 2px;
      margin: 20px 16px 0 40px;
      overflow: hidden;
    }
  }

  .icon-line {
    height: 19 * 2px;
    width: 297 * 2px;
    margin: 17 * 2px 0 0;
    // background: url('https://oss.turingsenseai.com/1661167391427961499.png') no-repeat center;
    background: url('https://oss.turingsenseai.com/1680748844129831419.png') no-repeat left;
    background-size: contain;
    
  }

  .detail_container {
    .point_content {
      width: 100%;
      border-top: 1px solid RGB(240, 240, 245);
      .ponit_pic {
        position: relative;
        display: flex;
        align-items: center;
        margin: 20 * 2px 0;
        justify-content: center;
        &.hasFake {
          justify-content: space-between;
        }
        .picT,
        .picF {
          display: flex;
          justify-content: center;
          flex-direction: column;
          align-items: center;
          img {
            width: 265px;
            height: 265px;
          }
        }
        .picF {
          position: relative;
          .fake_mark {
            position: absolute;
            border: 1px solid red;
            z-index: 7;
            border-radius: 45px;
            width: 9%;
            height: 8%;
          }
        }
        .pic_markT {
          position: absolute;
          top: 0;
          z-index: 6;
          width: 60%;
          height: 94%;
        }
        .pic_markF {
          position: absolute;
          top: 0;
          z-index: 6;
          height: 3.5rem;
          width: 3.5rem;
        }
        img {
          width: 35%;
          height: 35%;
          background-color: black;
          object-fit: contain;
          margin-bottom: 10px;
        }
        .trueArea {
          position: absolute;
          background-color: rgba(0, 0, 0, 0);
          object-fit: fill;
        }
        // 真
        .trueP {
          display: flex;
          flex-direction: column;
          justify-content: center;
          align-items: center;
          .truePic {
            width: 60%;
            height: 100%;
            background-color: black;
            object-fit: contain;
            margin-bottom: 10px;
          }
        }
      }
      .point_dsc {
        width: 100%;
        background-color: #F8F8F8;
        padding: 20px;
      }
    }
  }
}
.safe-bottom {
  height: 150px;
}

.text111{
  font-weight: 400;
  font-size: 6px;
  // line-height: 32px;
  color: #828393;
  background: #fff;
  margin-top: 20px;
  padding: 30px;
  width: 100%;
}

.text111 *{
  line-height: 38px;
  font-size: 6px;
}

</style>
